import { useNavigate, useParams } from 'react-router-dom';

import { useOneInternalInvoice } from 'lib/hooks/queries/billing/useOneInternalInvoice';

import InvoiceStepModal from './InvoiceStepModal';

const ViewInternalInvoice = () => {
  const { invoiceId } = useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useOneInternalInvoice({
    params: { id: invoiceId },
    dependencies: [invoiceId]
  });

  return (
    <InvoiceStepModal
      isOpen={!!data?.invoice}
      item={data?.invoice}
      isLoading={isLoading}
      handleClose={() => navigate('..')}
    />
  );
};

export default ViewInternalInvoice;
